export const isTouchDevice = () => typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0;
